<template>
	<div id="forgot">
		<h2>{{$t('forgot.RecoverPassword')}}</h2>
		<p>{{$t('forgot.RecoverPasswordTip')}}</p>
		<div class="icons">
			<div @click="openDialog('phone')">
				<span><img src="../assets/home-security-3.png" alt=""></span>
				<b>{{$t('forgot.SecurityMobilePhone')}}</b>
			</div>
			<div @click="openDialog('email')">
				<span><img src="../assets/home-security-4.png" alt=""></span>
				<b>{{$t('forgot.SecurityEmail')}}</b>
			</div>
			<div @click="openDialog('question')">
				<span><img src="../assets/home-security-5.png" alt=""></span>
				<b>{{$t('forgot.SecurityQuestion')}}</b>
			</div>
		</div>
		<template v-if="dialog">
			<div class="dialog-bg">
				<div class="dialog-container">
					<a href="javascript:;" class="dialog-close-btn" @click="dialog = ''"></a>
					<div class="form-container">
						<div class="form-item">
							<label for="">{{$t('forgot.UserName')}}</label>
							<span>{{account}}</span>
						</div>
						<div class="form-item" v-if="dialog=='phone'">
							<label for="">{{$t('forgot.SecurityMobilePhone')}}</label>
							<span>{{phone}}</span>
						</div>
						<div class="form-item" v-if="dialog=='email'">
							<label for="">{{$t('forgot.SecurityEmail')}}</label>
							<span>{{email}}</span>
						</div>
						<div class="form-item" v-if="dialog=='question'">
							<label for="">{{$t('forgot.SecurityQuestion')}}</label>
							<span>{{question}}</span>
						</div>
						<div class="form-item" v-if="dialog=='question'">
							<label for="">{{$t('forgot.SecurityAnswer')}}</label>
							<input type="text" v-model="securityAnswer"  @focus="validated = false" :class="(validated && !securityAnswer) ? 'error' : ''" :placeholder="$t('forgot.SecurityAnswerTip')">
						</div>
						<div class="form-item">
							<label for="">{{$t('forgot.NewPassword')}}</label>
							<input type="password" v-model="newPassword"  @focus="validated = false" :class="(validated && !newPassword) ? 'error' : ''" :placeholder="$t('forgot.NewPasswordTip')">
						</div>
						<div class="form-item">
							<label for="">{{$t('forgot.ConfirmPassword')}}</label>
							<input type="password" v-model="confirmPassword"  @focus="validated = false" :class="(validated && !confirmPassword) ? 'error' : ''" :placeholder="$t('forgot.NewPasswordAgainTip')">
						</div>
						<div class="form-item code-item" v-if="dialog=='phone'">
							<label for="">{{$t("default.MessageAuthenticationCode")}}</label>
							<input type="text"
								@focus="validated = false" 
								class="code-input" 
								maxlength="6" 
								v-model="messageAuthenticationCode" 
								:placeholder="$t('default.VerificationCodeTip')" 
								:class="(validated && !messageAuthenticationCode) ? 'error' : ''" />
							<span><wd-button ref="message-code-btn" @click.native="sendCode" type="info" size="small" :styles="{height:'44px',padding:'5px 15px'}">{{$t('default.SendVerificationCode')}}</wd-button></span>
						</div>
						<div class="form-item code-item" v-if="dialog=='email'">
							<label for="">{{$t("default.EmailAuthenticationCode")}}</label>
							<input type="text"
								@focus="validated = false" 
								class="code-input" 
								maxlength="6" 
								v-model="emailAuthenticationCode" 
								:placeholder="$t('default.VerificationCodeTip')" 
								:class="(validated && !emailAuthenticationCode) ? 'error' : ''" />
							<span>
								<wd-button ref="email-code-btn" @click.native="sendCode" type="info" size="small" :styles="{height:'44px'}">{{$t('default.SendVerificationCode')}}</wd-button></span>
						</div>
						<div class="form-item">
							<label for=""></label>
							<wd-button type="danger" @click.native="submit" size="large" :styles="{width:'300px'}">{{$t("default.submit")}}</wd-button>
							
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>
<script>
	import WdButton from '@/components/WdButton.vue';
	export default{
		name:"forgot",
		data(){
			return {
				dialog:'',
				account:'',
				phone:'',
				email:'',
				question:'',
				newPassword:'',
				confirmPassword:'',
				messageAuthenticationCode:'',
				emailAuthenticationCode:'',
				securityAnswer:'',
				validated:false,
			}
		},
		components:{
			'wd-button':WdButton
		},
		methods:{
			async submit(){
				this.validated = true;
				if(!this.newPassword){
					this.$alert(this.$t('forgot.NewPasswordTip'));
					return;
				}
				if(!this.confirmPassword){
					this.$alert(this.$t('forgot.NewPasswordAgainTip'));
					return;
				}
				if(this.newPassword != this.confirmPassword){
					this.$alert(this.$t('forgot.PasswordsNotMatch'));
					return;
				}
				let postData = {
					account:this.account,
					password:this.newPassword,
					confirm_password:this.confirmPassword
				}

				if(this.dialog == 'phone' && !this.messageAuthenticationCode){
					this.$alert(this.$t('default.VerificationCodeTip'));
					return;
				}
				if(this.dialog == 'email' && !this.emailAuthenticationCode){
					this.$alert(this.$t('default.VerificationCodeTip'));
					return;
				}
				if(this.dialog == 'question' && !this.securityAnswer){
					this.$alert(this.$t('forgot.SecurityAnswerTip'));
					return;
				}
				if(this.dialog == 'phone'){
					postData.phone = this.phone;
					postData.code = this.messageAuthenticationCode;
				}
				if(this.dialog == 'email'){
					postData.email = this.email;
					postData.code = this.emailAuthenticationCode;
				}
				if(this.dialog == 'question'){
					postData.security_question = this.question;
					postData.answer = this.securityAnswer;
				}

				let response = await this.$api.post('/web/basic/getPassword',postData);
				if(response.code == 0){
					this.$alert(this.$t('forgot.PasswordChangeSuccess'));
					this.dialog = '';
				}else{
					this.$alert(response.msg);
				}


			},
			sendCode(){
				if(this.dialog == 'email'){
					this.$refs['email-code-btn'].sendEmailCode('forgot',this.email)
				}else if(this.dialog == 'phone'){
					this.$refs['message-code-btn'].sendMessageCode('forgot',this.phone)
				}
				
			},
			openDialog(type){
				if(type == 'phone' && !this.phone){
					this.$alert(this.$t('forgot.NotBoundPhone'));
					return;
				}
				if(type == 'email' && !this.email){
					this.$alert(this.$t('forgot.NotBoundEmail'));
					return;
				}
				if(type == 'question' && !this.question){
					this.$alert(this.$t('forgot.NotSetQuestion'));
					return;
				}
				this.dialog = type;
			}
		},
		async created(){
			let user = await this.$getUser();
			if(user){
				this.account = user.account;
				this.phone = user.phone;
				this.email = user.email;
				this.question = user.security_question;
			}
		},
		mounted(){

		}
	}
</script>
<style scoped>
	#forgot{
		width: 500px;
		margin: 0px auto;
		margin-top: 50px;
	}
	h2{
		margin-bottom: 10px;
	}
	p{
		font-size: 14px;
	}
	.icons{
		display: flex;
		margin-top: 30px;
	}
	.icons div{
		flex:1;
		cursor: pointer;
	}
	.icons div span{
		border: 1px solid #818599;
		width: 100px;
		height: 100px;
		padding: 3px;
		border-radius: 50%;
		box-sizing: border-box;
		display: block;
		text-align: center;
		margin: 0px auto
	}
	.icons div span:hover{
		border: 1px solid #c72729;
	}
	.icons div span img{
		background-color: #818599;
		width: 100%;
		height: 100%;
		border-radius: 50%;
		padding: 20px;
		box-sizing: border-box;
	}
	.icons div span:hover img{
		background-color: #c72729;
	}
	.icons div b{
		display: block;
		text-align: center;
		margin-top: 15px;
	}
	.icons div:hover b{
		color: #c72729;
	}
	.form-container{
		width: 100%;
	}
</style>